<template>
  <div class="df-container df-alert" v-if="value">
    <div class="mask"></div>
    <div class="df-main alert">
      <div class="container">
        <div class="title">{{info.title}}</div>
        <div class="content">{{info.content}}</div>
      </div>
      <div class="button" @click="close()">{{info.buttonText}}</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'alert',
    data:function () {
      return {

      }
    },
    props: [
      'value',
      'info',
    ],
    created () {

    },
    watch:{

    },
    methods: {
      close(){
        this.$emit("on-hide");
      }
    },
  }
</script>

<style lang="scss" scoped type="text/scss">
  @import "css/common";
  .df-main{
    .button{
      display: flex;
      justify-content: center;
      padding: 30px;
      box-sizing: border-box;
      color: $mainColor;
      font-size: 30px;
    }
  }
</style>
